export enum COMPANY_TYPE {
    PUBLIC = 'Public',
    NON_PROFILE = 'Non-Profile',
    PRIVATE = 'Private',
}